import { forwardRef, type Ref, type SVGProps } from "react";
const IconWindFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M15.3 28q-1.12 0-2.083-.565a4.4 4.4 0 0 1-1.557-1.553q-.385-.705-.018-1.411.368-.706 1.138-.706.455 0 .805.282t.63.635q.175.248.473.37.297.125.612.125.596 0 .997-.406.403-.406.403-1.006t-.402-1.006-.998-.406H3.4a1.35 1.35 0 0 1-.997-.406A1.37 1.37 0 0 1 2 20.941q0-.6.402-1.006.403-.405.998-.406h11.9q1.75 0 2.975 1.236t1.225 3-1.225 3T15.3 28M3.4 13.882q-.596 0-.997-.405A1.37 1.37 0 0 1 2 12.47q0-.6.402-1.006.403-.405.998-.406h17.5q.875 0 1.488-.618.612-.618.612-1.5t-.613-1.5a2.02 2.02 0 0 0-1.487-.617q-.56 0-1.05.264-.49.265-.77.76a3.4 3.4 0 0 1-.595.758 1.17 1.17 0 0 1-.84.335q-.7 0-1.137-.53-.438-.529-.228-1.129A4.6 4.6 0 0 1 18.047 4.9Q19.325 4 20.9 4q2.03 0 3.465 1.447T25.8 8.941t-1.435 3.494-3.465 1.447zm23.73 10.87q-.7.319-1.365-.087-.665-.405-.665-1.183 0-.494.332-.83.333-.335.753-.581a1.9 1.9 0 0 0 .753-.777q.262-.494.262-1.059 0-.882-.613-1.5a2.02 2.02 0 0 0-1.487-.617H3.4q-.596 0-.997-.406A1.37 1.37 0 0 1 2 16.706q0-.6.402-1.006.403-.405.998-.406h21.7q2.03 0 3.465 1.447T30 20.235a4.95 4.95 0 0 1-.77 2.7 4.73 4.73 0 0 1-2.1 1.818" />
  </svg>
);
const ForwardRef = forwardRef(IconWindFilledSVG);
ForwardRef.displayName = "IconWindFilled";
export { ForwardRef as IconWindFilled };
